export function getWithDefault(object, key, defaultValue) {
  return key in object ? object[key] : defaultValue;
}
